import api from '../../helpers/api';
import { IActionsLogState, IActionLogPayload } from './ActionsLog-types';

const actionsLogState: IActionsLogState = {
    state: {
        actionsLog: [],
    },
    mutations: {
        setActionsLog(state, actionsLog: IActionLogPayload[]) {
            state.actionsLog = actionsLog;
        },
    },
    actions: {
        async getActionsLog({ commit }, gameId: number) {
            const response = await api.request(`/game/${gameId}/log`);
            const actionsLog: IActionLogPayload[] = await response.json();

            if (response.ok) {
                commit('setActionsLog', actionsLog);
            }
        },
        async setActionsLog({ commit }, actionsLog: IActionLogPayload[]) {
            commit('setActionsLog', actionsLog);
        },
    },
};

export default actionsLogState;
